module.exports = __webpack_public_path__ + "img/harry-mohr.25552de0.png";